import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { getProfile } from "../../../redux/profile/action";
import { loginWithSocial } from "../../../redux/zservices/BasicAPIFunctions";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

const LINKEDIN_SOCIAL_FROM = Number(
  process.env.REACT_APP_LINKEDIN_SOCIAL_FROM || 4
);

export default function LinkedInCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lan = localStorage.getItem("laung") || "en";
  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    const completeLinkedInLogin = async () => {
      const status = searchParams.get("status");
      const message = searchParams.get("message");
      const socialToken =
        searchParams.get("token") ||
        searchParams.get("social_token") ||
        searchParams.get("access_token");

      if (status === "error" || !socialToken) {
        urtoast(message || "LinkedIn login failed", 2);
        navigate(`/${lan}/loginwithemail`, { replace: true });
        return;
      }

      try {
        const loginRes = await loginWithSocial({
          social_from: LINKEDIN_SOCIAL_FROM,
          social_token: socialToken,
        });

        if (loginRes?.data?.response?.token) {
          const { token, role_type, refresh_token } = loginRes.data.response;

          localStorage.setItem("urexperttoken", token);
          localStorage.setItem("role_type", role_type);
          localStorage.setItem("refresh_token", refresh_token);

          dispatch(getProfile());
          urtoast(loginRes.data.response.message, 1);
          navigate(`/${lan}/account`, { replace: true });
        } else {
          navigate(`/${lan}/signup`, {
            replace: true,
            state: {
              social_from: LINKEDIN_SOCIAL_FROM,
              social_token: socialToken,
            },
          });
          urtoast(
            loginRes?.data?.response?.message || "Please complete signup",
            1
          );
        }
      } catch (error) {
        urtoast(error?.message || "LinkedIn login failed", 2);
        navigate(`/${lan}/loginwithemail`, { replace: true });
      }
    };

    completeLinkedInLogin();
  }, [dispatch, lan, navigate, searchParams]);

  return (
    <div className="mx-auto register">
      <h1 className="heading">Login account.</h1>
      <div className="col-md-8 mx-auto form-sec login-email text-center">
        <p>Completing LinkedIn login...</p>
      </div>
    </div>
  );
}
